import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useReveal } from "@/lib/useReveal";

export const FinalCta = () => {
  const ref = useReveal();
  return (
    <section id="join" data-testid="final-cta-section" className="relative py-20 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref}
          className="reveal relative overflow-hidden rounded-3xl border border-neon-lime/25 bg-gradient-to-br from-ink-1 to-ink-2 p-8 sm:p-14 shadow-glow-lime"
        >
          <div
            className="absolute inset-0 pointer-events-none noise-overlay"
            aria-hidden="true"
            style={{
              background:
                "radial-gradient(600px circle at 10% 0%, rgba(191,255,0,0.22), transparent 60%), radial-gradient(500px circle at 100% 100%, rgba(15,240,252,0.14), transparent 60%)",
            }}
          />
          <div
            className="absolute -top-8 -right-8 h-64 w-64 rounded-full blur-3xl opacity-40 orb-float-1"
            style={{ background: "radial-gradient(circle, rgba(191,255,0,0.5), transparent 60%)" }}
            aria-hidden="true"
          />
          <div className="relative grid gap-6 lg:grid-cols-12 items-center">
            <div className="lg:col-span-8">
              <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs uppercase tracking-widest text-white/70">
                <span className="h-1.5 w-1.5 rounded-full bg-neon-lime pulse-dot" />
                14-day free trial
              </div>
              <h2 className="mt-4 font-display text-4xl sm:text-6xl tracking-tight text-white leading-[0.95]">
                YOUR NEXT PR
                <br />
                <span className="text-neon-lime">STARTS TODAY.</span>
              </h2>
              <p className="mt-4 text-white/75 max-w-xl">
                Join 120,000+ athletes training smarter with Pulse. No credit card needed to start.
              </p>
            </div>
            <div className="lg:col-span-4 flex lg:justify-end">
              <a href="#pricing" className="w-full sm:w-auto">
                <Button
                  data-testid="final-cta-button"
                  className="btn-lift w-full sm:w-auto h-14 px-8 rounded-xl bg-neon-lime text-ink-0 hover:bg-neon-lime hover:brightness-95 font-semibold text-base shadow-glow-lime"
                >
                  Start Free Trial
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
